export const CountryDownloadBoxContext = {
  WISHLIST: "WISHLIST",
  DOWNLOAD_LIST_TEASER: "DOWNLOAD_LIST_TEASER"
};

export const DownloadCategory = {
  APPROVALS: "approvals",
  CERTIFICATES: "certificates"
};

export const DOWNLOADMATRIX_LANGUAGES = [
  "EN",
  "DE",
  "ES",
  "FR",
  "BG",
  "BR",
  "CZ",
  "DK",
  "EL",
  "FI",
  "HR",
  "HU",
  "IT",
  "JA",
  "KR",
  "KO",
  "KZ",
  "LT",
  "NL",
  "NO",
  "PT",
  "PL",
  "RO",
  "RU",
  "SE",
  "SK",
  "SR",
  "TR",
  "UQ",
  "ZH",
  "UK",
  "UA",
  "US"
];
